/* tslint:disable */
/* eslint-disable */
/**
 * Ticketminds API
 * Ticketminds API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: olivier@devminds.be
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BaseEvent
 */
export interface BaseEvent {
    /**
     * 
     * @type {number}
     * @memberof BaseEvent
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    'urlSlug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    'startsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    'endsAt'?: string | null;
    /**
     * 
     * @type {EventVisibility}
     * @memberof BaseEvent
     */
    'visibility'?: EventVisibility | null;
    /**
     * 
     * @type {EventAvailability}
     * @memberof BaseEvent
     */
    'availability'?: EventAvailability | null;
    /**
     * 
     * @type {number}
     * @memberof BaseEvent
     */
    'venueId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    'logo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BaseEvent
     */
    'eventgroupId'?: number;
    /**
     * 
     * @type {Eventgroup}
     * @memberof BaseEvent
     */
    'eventgroup'?: Eventgroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof BaseEvent
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    'createdOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    'lastModifiedOn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    'lastModifiedBy'?: string | null;
    /**
     * 
     * @type {EventType}
     * @memberof BaseEvent
     */
    'type'?: EventType | null;
    /**
     * 
     * @type {Array<SubscriptionEvent>}
     * @memberof BaseEvent
     */
    'subscriptionEvents'?: Array<SubscriptionEvent> | null;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    'tenant'?: string | null;
}
/**
 * 
 * @export
 * @interface CcvWebhookModel
 */
export interface CcvWebhookModel {
    /**
     * 
     * @type {string}
     * @memberof CcvWebhookModel
     */
    'Id'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomerInfo
 */
export interface CustomerInfo {
    /**
     * 
     * @type {number}
     * @memberof CustomerInfo
     */
    'customerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'customerFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'customerLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'company'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomerInfoDto
 */
export interface CustomerInfoDto {
    /**
     * 
     * @type {number}
     * @memberof CustomerInfoDto
     */
    'customerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfoDto
     */
    'customerFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfoDto
     */
    'customerLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfoDto
     */
    'company'?: string | null;
}
/**
 * 
 * @export
 * @interface Enumeration
 */
export interface Enumeration {
    /**
     * 
     * @type {string}
     * @memberof Enumeration
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Enumeration
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface Enumeration2
 */
export interface Enumeration2 {
    /**
     * 
     * @type {string}
     * @memberof Enumeration2
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Enumeration2
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EventAvailability
 */
export interface EventAvailability {
    /**
     * 
     * @type {string}
     * @memberof EventAvailability
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventAvailability
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EventSeatAvailability
 */
export interface EventSeatAvailability {
    /**
     * 
     * @type {string}
     * @memberof EventSeatAvailability
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventSeatAvailability
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EventSeatSmallDto
 */
export interface EventSeatSmallDto {
    /**
     * 
     * @type {EventSeatAvailability}
     * @memberof EventSeatSmallDto
     */
    'state'?: EventSeatAvailability | null;
    /**
     * 
     * @type {number}
     * @memberof EventSeatSmallDto
     */
    'config'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventSeatSmallDto
     */
    'code'?: string | null;
}
/**
 * 
 * @export
 * @interface EventType
 */
export interface EventType {
    /**
     * 
     * @type {string}
     * @memberof EventType
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventType
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EventVisibility
 */
export interface EventVisibility {
    /**
     * 
     * @type {string}
     * @memberof EventVisibility
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventVisibility
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface Eventgroup
 */
export interface Eventgroup {
    /**
     * 
     * @type {number}
     * @memberof Eventgroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Eventgroup
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Eventgroup
     */
    'urlSlug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Eventgroup
     */
    'category'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Eventgroup
     */
    'seasonId'?: number;
    /**
     * 
     * @type {Season}
     * @memberof Eventgroup
     */
    'season'?: Season | null;
    /**
     * 
     * @type {boolean}
     * @memberof Eventgroup
     */
    'isVisible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Eventgroup
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Eventgroup
     */
    'createdOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof Eventgroup
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Eventgroup
     */
    'lastModifiedOn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Eventgroup
     */
    'lastModifiedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Eventgroup
     */
    'tenant'?: string | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfEventSeatSmallDto
 */
export interface PagedResultOfEventSeatSmallDto {
    /**
     * 
     * @type {Array<EventSeatSmallDto>}
     * @memberof PagedResultOfEventSeatSmallDto
     */
    'results'?: Array<EventSeatSmallDto> | null;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfEventSeatSmallDto
     */
    'currentPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfEventSeatSmallDto
     */
    'pagesize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedResultOfEventSeatSmallDto
     */
    'hasMorePages'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfEventSeatSmallDto
     */
    'totalResults'?: number;
}
/**
 * 
 * @export
 * @interface PagedResultOfReservationDto
 */
export interface PagedResultOfReservationDto {
    /**
     * 
     * @type {Array<ReservationDto>}
     * @memberof PagedResultOfReservationDto
     */
    'results'?: Array<ReservationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfReservationDto
     */
    'currentPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfReservationDto
     */
    'pagesize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedResultOfReservationDto
     */
    'hasMorePages'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfReservationDto
     */
    'totalResults'?: number;
}
/**
 * 
 * @export
 * @interface PagedResultOfSubscriptionSeatSmallDto
 */
export interface PagedResultOfSubscriptionSeatSmallDto {
    /**
     * 
     * @type {Array<SubscriptionSeatSmallDto>}
     * @memberof PagedResultOfSubscriptionSeatSmallDto
     */
    'results'?: Array<SubscriptionSeatSmallDto> | null;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfSubscriptionSeatSmallDto
     */
    'currentPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfSubscriptionSeatSmallDto
     */
    'pagesize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedResultOfSubscriptionSeatSmallDto
     */
    'hasMorePages'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfSubscriptionSeatSmallDto
     */
    'totalResults'?: number;
}
/**
 * 
 * @export
 * @interface Pricing
 */
export interface Pricing {
    /**
     * 
     * @type {number}
     * @memberof Pricing
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pricing
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Pricing
     */
    'category'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Pricing
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface PricingInfo
 */
export interface PricingInfo {
    /**
     * 
     * @type {number}
     * @memberof PricingInfo
     */
    'priceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PricingInfo
     */
    'eventSeatPriceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PricingInfo
     */
    'subscriptionSeatPriceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PricingInfo
     */
    'price'?: number | null;
}
/**
 * 
 * @export
 * @interface PricingInfoDto
 */
export interface PricingInfoDto {
    /**
     * 
     * @type {number}
     * @memberof PricingInfoDto
     */
    'priceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PricingInfoDto
     */
    'eventSeatPriceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PricingInfoDto
     */
    'subscriptionSeatPriceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PricingInfoDto
     */
    'price'?: number | null;
}
/**
 * 
 * @export
 * @interface PublicCancelEventReservationModel
 */
export interface PublicCancelEventReservationModel {
    /**
     * 
     * @type {number}
     * @memberof PublicCancelEventReservationModel
     */
    'ReservationId'?: number;
}
/**
 * 
 * @export
 * @interface PublicCancelSubscriptionReservationModel
 */
export interface PublicCancelSubscriptionReservationModel {
    /**
     * 
     * @type {number}
     * @memberof PublicCancelSubscriptionReservationModel
     */
    'SubscriptionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicCancelSubscriptionReservationModel
     */
    'SeatCode'?: string | null;
}
/**
 * 
 * @export
 * @interface PublicCreateEventReservationModel
 */
export interface PublicCreateEventReservationModel {
    /**
     * 
     * @type {number}
     * @memberof PublicCreateEventReservationModel
     */
    'EventId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicCreateEventReservationModel
     */
    'SeatCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PublicCreateEventReservationModel
     */
    'PriceId'?: number | null;
}
/**
 * 
 * @export
 * @interface PublicCreateSubscriptionReservationModel
 */
export interface PublicCreateSubscriptionReservationModel {
    /**
     * 
     * @type {number}
     * @memberof PublicCreateSubscriptionReservationModel
     */
    'SubscriptionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicCreateSubscriptionReservationModel
     */
    'SeatCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PublicCreateSubscriptionReservationModel
     */
    'PriceId'?: number | null;
}
/**
 * 
 * @export
 * @interface PublicUpdateEventReservationModel
 */
export interface PublicUpdateEventReservationModel {
    /**
     * 
     * @type {number}
     * @memberof PublicUpdateEventReservationModel
     */
    'ReservationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicUpdateEventReservationModel
     */
    'ReservationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicUpdateEventReservationModel
     */
    'Language'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PublicUpdateEventReservationModel
     */
    'PriceId'?: number | null;
}
/**
 * 
 * @export
 * @interface PublicUpdateSubscriptionReservationModel
 */
export interface PublicUpdateSubscriptionReservationModel {
    /**
     * 
     * @type {number}
     * @memberof PublicUpdateSubscriptionReservationModel
     */
    'SubscriptionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicUpdateSubscriptionReservationModel
     */
    'SeatCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicUpdateSubscriptionReservationModel
     */
    'Language'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PublicUpdateSubscriptionReservationModel
     */
    'PriceId'?: number | null;
}
/**
 * 
 * @export
 * @interface Reservation
 */
export interface Reservation {
    /**
     * 
     * @type {number}
     * @memberof Reservation
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Reservation
     */
    'seatId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Reservation
     */
    'seatCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Reservation
     */
    'expirationTimestamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Reservation
     */
    'createdOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof Reservation
     */
    'reservationCode'?: string | null;
    /**
     * 
     * @type {ReservationStatus}
     * @memberof Reservation
     */
    'status'?: ReservationStatus | null;
    /**
     * 
     * @type {number}
     * @memberof Reservation
     */
    'orderId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Reservation
     */
    'orderReference'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Reservation
     */
    'orderItemId'?: number | null;
    /**
     * 
     * @type {ReservationType}
     * @memberof Reservation
     */
    'reservationType'?: ReservationType | null;
    /**
     * 
     * @type {string}
     * @memberof Reservation
     */
    'remarks'?: string | null;
    /**
     * 
     * @type {Source}
     * @memberof Reservation
     */
    'source'?: Source | null;
    /**
     * 
     * @type {ReservationCancellationReason}
     * @memberof Reservation
     */
    'cancellationReason'?: ReservationCancellationReason | null;
    /**
     * 
     * @type {CustomerInfo}
     * @memberof Reservation
     */
    'customer'?: CustomerInfo | null;
    /**
     * 
     * @type {number}
     * @memberof Reservation
     */
    'eventId'?: number | null;
    /**
     * 
     * @type {BaseEvent}
     * @memberof Reservation
     */
    'event'?: BaseEvent | null;
    /**
     * 
     * @type {number}
     * @memberof Reservation
     */
    'subscriptionId'?: number | null;
    /**
     * 
     * @type {Subscription}
     * @memberof Reservation
     */
    'subscription'?: Subscription | null;
    /**
     * 
     * @type {SupportedLanguage}
     * @memberof Reservation
     */
    'language'?: SupportedLanguage | null;
    /**
     * 
     * @type {PricingInfo}
     * @memberof Reservation
     */
    'pricing'?: PricingInfo | null;
    /**
     * 
     * @type {boolean}
     * @memberof Reservation
     */
    'isVisible'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Reservation
     */
    'tenant'?: string | null;
}
/**
 * 
 * @export
 * @interface ReservationCancellationReason
 */
export interface ReservationCancellationReason {
    /**
     * 
     * @type {string}
     * @memberof ReservationCancellationReason
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationCancellationReason
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ReservationDto
 */
export interface ReservationDto {
    /**
     * 
     * @type {EventType}
     * @memberof ReservationDto
     */
    'eventType'?: EventType | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReservationDto
     */
    'seatId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReservationDto
     */
    'seatCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationDto
     */
    'expirationTimestamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationDto
     */
    'createdOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationDto
     */
    'reservationCode'?: string | null;
    /**
     * 
     * @type {ReservationStatus}
     * @memberof ReservationDto
     */
    'status'?: ReservationStatus | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationDto
     */
    'orderId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationDto
     */
    'orderReference'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationDto
     */
    'orderItemId'?: number | null;
    /**
     * 
     * @type {ReservationType}
     * @memberof ReservationDto
     */
    'reservationType'?: ReservationType | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationDto
     */
    'remarks'?: string | null;
    /**
     * 
     * @type {Source}
     * @memberof ReservationDto
     */
    'source'?: Source | null;
    /**
     * 
     * @type {ReservationCancellationReason}
     * @memberof ReservationDto
     */
    'cancellationReason'?: ReservationCancellationReason | null;
    /**
     * 
     * @type {CustomerInfoDto}
     * @memberof ReservationDto
     */
    'customer'?: CustomerInfoDto | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationDto
     */
    'eventId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationDto
     */
    'subscriptionId'?: number | null;
    /**
     * 
     * @type {SupportedLanguage}
     * @memberof ReservationDto
     */
    'language'?: SupportedLanguage | null;
    /**
     * 
     * @type {PricingInfoDto}
     * @memberof ReservationDto
     */
    'pricing'?: PricingInfoDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReservationDto
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @interface ReservationSeatStatusDto
 */
export interface ReservationSeatStatusDto {
    /**
     * 
     * @type {string}
     * @memberof ReservationSeatStatusDto
     */
    'seatCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationSeatStatusDto
     */
    'status'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReservationSeatStatusDto
     */
    'type'?: number;
}
/**
 * 
 * @export
 * @interface ReservationSeatStatusWithCodes
 */
export interface ReservationSeatStatusWithCodes {
    /**
     * 
     * @type {Array<ReservationSeatStatusDto>}
     * @memberof ReservationSeatStatusWithCodes
     */
    'results'?: Array<ReservationSeatStatusDto> | null;
    /**
     * 
     * @type {Array<ReservationStatus>}
     * @memberof ReservationSeatStatusWithCodes
     */
    'status'?: Array<ReservationStatus> | null;
    /**
     * 
     * @type {Array<ReservationType>}
     * @memberof ReservationSeatStatusWithCodes
     */
    'type'?: Array<ReservationType> | null;
}
/**
 * 
 * @export
 * @interface ReservationStatus
 */
export interface ReservationStatus {
    /**
     * 
     * @type {string}
     * @memberof ReservationStatus
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationStatus
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ReservationType
 */
export interface ReservationType {
    /**
     * 
     * @type {string}
     * @memberof ReservationType
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationType
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ScanResult
 */
export interface ScanResult {
    /**
     * 
     * @type {string}
     * @memberof ScanResult
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ScanResult
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ScanResult
     */
    'isValid'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ScanResult2 {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4
}

/**
 * 
 * @export
 * @interface ScanResultAllOf
 */
export interface ScanResultAllOf {
    /**
     * 
     * @type {boolean}
     * @memberof ScanResultAllOf
     */
    'isValid'?: boolean;
}
/**
 * 
 * @export
 * @interface ScanTicketCommand
 */
export interface ScanTicketCommand {
    /**
     * 
     * @type {string}
     * @memberof ScanTicketCommand
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScanTicketCommand
     */
    'eventId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketCommand
     */
    'ticketCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketCommand
     */
    'device'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketCommand
     */
    'user'?: string | null;
    /**
     * 
     * @type {ScanResult2}
     * @memberof ScanTicketCommand
     */
    'clientResult'?: ScanResult2;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketCommand
     */
    'clientTimestamp'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScanTicketCommand
     */
    'serverValidation'?: boolean;
}
/**
 * 
 * @export
 * @interface ScanTicketResponse
 */
export interface ScanTicketResponse {
    /**
     * 
     * @type {ScanResult}
     * @memberof ScanTicketResponse
     */
    'scanResult'?: ScanResult | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketResponse
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketResponse
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketResponse
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketResponse
     */
    'company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketResponse
     */
    'seatCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketResponse
     */
    'ticketType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketResponse
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketResponse
     */
    'createdOn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketResponse
     */
    'subscription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanTicketResponse
     */
    'status'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ScanTicketResponse
     */
    'ticketId'?: number | null;
}
/**
 * 
 * @export
 * @interface ScannerEventModel
 */
export interface ScannerEventModel {
    /**
     * 
     * @type {number}
     * @memberof ScannerEventModel
     */
    'Id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScannerEventModel
     */
    'StartsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScannerEventModel
     */
    'EndsAt'?: string | null;
    /**
     * 
     * @type {EventVisibility}
     * @memberof ScannerEventModel
     */
    'Visibility'?: EventVisibility | null;
    /**
     * 
     * @type {EventAvailability}
     * @memberof ScannerEventModel
     */
    'Availability'?: EventAvailability | null;
    /**
     * 
     * @type {string}
     * @memberof ScannerEventModel
     */
    'Logo'?: string | null;
    /**
     * 
     * @type {EventType}
     * @memberof ScannerEventModel
     */
    'Type'?: EventType | null;
    /**
     * 
     * @type {string}
     * @memberof ScannerEventModel
     */
    'Title'?: string | null;
    /**
     * 
     * @type {Team}
     * @memberof ScannerEventModel
     */
    'Home'?: Team | null;
    /**
     * 
     * @type {Team}
     * @memberof ScannerEventModel
     */
    'Guest'?: Team | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScannerEventModel
     */
    'Codes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ScannerEventView
 */
export interface ScannerEventView {
    /**
     * 
     * @type {number}
     * @memberof ScannerEventView
     */
    'Id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScannerEventView
     */
    'Type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScannerEventView
     */
    'Title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScannerEventView
     */
    'EventStart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScannerEventView
     */
    'EventEnd'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScannerEventView
     */
    'VerificationCodes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScannerEventView
     */
    'CodeKeysList'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface Season
 */
export interface Season {
    /**
     * 
     * @type {number}
     * @memberof Season
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'end'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Season
     */
    'isCurrent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Season
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'createdOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'lastModifiedOn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'lastModifiedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'tenant'?: string | null;
}
/**
 * 
 * @export
 * @interface SeatConfigurationDto
 */
export interface SeatConfigurationDto {
    /**
     * 
     * @type {number}
     * @memberof SeatConfigurationDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof SeatConfigurationDto
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SeatConfigurationDto
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SeatConfigurationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<Pricing>}
     * @memberof SeatConfigurationDto
     */
    'prices'?: Array<Pricing> | null;
}
/**
 * 
 * @export
 * @interface Source
 */
export interface Source {
    /**
     * 
     * @type {string}
     * @memberof Source
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Source
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'venueId'?: number;
    /**
     * 
     * @type {SubscriptionVisibility}
     * @memberof Subscription
     */
    'visibility'?: SubscriptionVisibility | null;
    /**
     * 
     * @type {SubscriptionAvailability}
     * @memberof Subscription
     */
    'availability'?: SubscriptionAvailability | null;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'copyFromSubscriptionId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Subscription
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'createdOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'lastModifiedOn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'lastModifiedBy'?: string | null;
    /**
     * 
     * @type {Array<SubscriptionEvent>}
     * @memberof Subscription
     */
    'subscriptionEvents'?: Array<SubscriptionEvent> | null;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'seasonId'?: number;
    /**
     * 
     * @type {Season}
     * @memberof Subscription
     */
    'season'?: Season | null;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'tenant'?: string | null;
}
/**
 * 
 * @export
 * @interface SubscriptionAvailability
 */
export interface SubscriptionAvailability {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAvailability
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAvailability
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface SubscriptionEvent
 */
export interface SubscriptionEvent {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionEvent
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionEvent
     */
    'subscriptionId'?: number;
    /**
     * 
     * @type {Subscription}
     * @memberof SubscriptionEvent
     */
    'subscription'?: Subscription | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionEvent
     */
    'eventId'?: number;
    /**
     * 
     * @type {BaseEvent}
     * @memberof SubscriptionEvent
     */
    'event'?: BaseEvent | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionEvent
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionEvent
     */
    'createdOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionEvent
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionEvent
     */
    'lastModifiedOn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionEvent
     */
    'lastModifiedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionEvent
     */
    'tenant'?: string | null;
}
/**
 * 
 * @export
 * @interface SubscriptionSeatAvailability
 */
export interface SubscriptionSeatAvailability {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionSeatAvailability
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionSeatAvailability
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface SubscriptionSeatSmallDto
 */
export interface SubscriptionSeatSmallDto {
    /**
     * 
     * @type {SubscriptionSeatAvailability}
     * @memberof SubscriptionSeatSmallDto
     */
    'state'?: SubscriptionSeatAvailability | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionSeatSmallDto
     */
    'config'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionSeatSmallDto
     */
    'code'?: string | null;
}
/**
 * 
 * @export
 * @interface SubscriptionVisibility
 */
export interface SubscriptionVisibility {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionVisibility
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionVisibility
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface SupportedLanguage
 */
export interface SupportedLanguage {
    /**
     * 
     * @type {string}
     * @memberof SupportedLanguage
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SupportedLanguage
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SupportedLanguage
     */
    'threeLetterIsoCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupportedLanguage
     */
    'twoLetterIsoCode'?: string | null;
}
/**
 * 
 * @export
 * @interface SupportedLanguageAllOf
 */
export interface SupportedLanguageAllOf {
    /**
     * 
     * @type {string}
     * @memberof SupportedLanguageAllOf
     */
    'threeLetterIsoCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupportedLanguageAllOf
     */
    'twoLetterIsoCode'?: string | null;
}
/**
 * 
 * @export
 * @interface Team
 */
export interface Team {
    /**
     * 
     * @type {number}
     * @memberof Team
     */
    'Id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'FullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'ShortName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'Logo'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateReservationResponse
 */
export interface UpdateReservationResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationResponse
     */
    'orderReference'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateReservationResponse
     */
    'isSucceeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationResponse
     */
    'errorMessage'?: string | null;
}

/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsGetUpcomingEventsForScanner: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/events/scanner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsGetUpcomingEventsForScanner(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScannerEventModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsGetUpcomingEventsForScanner(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsGetUpcomingEventsForScanner(options?: any): AxiosPromise<Array<ScannerEventModel>> {
            return localVarFp.eventsGetUpcomingEventsForScanner(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public eventsGetUpcomingEventsForScanner(options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).eventsGetUpcomingEventsForScanner(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LegacyTicketsApi - axios parameter creator
 * @export
 */
export const LegacyTicketsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyTicketsGetUpcomingEventsForScanner: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/scanevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ScanTicketCommand} scanTicketCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyTicketsScanTicketCode: async (scanTicketCommand: ScanTicketCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanTicketCommand' is not null or undefined
            assertParamExists('legacyTicketsScanTicketCode', 'scanTicketCommand', scanTicketCommand)
            const localVarPath = `/scans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scanTicketCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegacyTicketsApi - functional programming interface
 * @export
 */
export const LegacyTicketsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegacyTicketsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyTicketsGetUpcomingEventsForScanner(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScannerEventView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.legacyTicketsGetUpcomingEventsForScanner(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ScanTicketCommand} scanTicketCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyTicketsScanTicketCode(scanTicketCommand: ScanTicketCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScanTicketResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.legacyTicketsScanTicketCode(scanTicketCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LegacyTicketsApi - factory interface
 * @export
 */
export const LegacyTicketsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegacyTicketsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyTicketsGetUpcomingEventsForScanner(options?: any): AxiosPromise<Array<ScannerEventView>> {
            return localVarFp.legacyTicketsGetUpcomingEventsForScanner(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ScanTicketCommand} scanTicketCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyTicketsScanTicketCode(scanTicketCommand: ScanTicketCommand, options?: any): AxiosPromise<ScanTicketResponse> {
            return localVarFp.legacyTicketsScanTicketCode(scanTicketCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegacyTicketsApi - object-oriented interface
 * @export
 * @class LegacyTicketsApi
 * @extends {BaseAPI}
 */
export class LegacyTicketsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyTicketsApi
     */
    public legacyTicketsGetUpcomingEventsForScanner(options?: AxiosRequestConfig) {
        return LegacyTicketsApiFp(this.configuration).legacyTicketsGetUpcomingEventsForScanner(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ScanTicketCommand} scanTicketCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyTicketsApi
     */
    public legacyTicketsScanTicketCode(scanTicketCommand: ScanTicketCommand, options?: AxiosRequestConfig) {
        return LegacyTicketsApiFp(this.configuration).legacyTicketsScanTicketCode(scanTicketCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MiscApi - axios parameter creator
 * @export
 */
export const MiscApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} challenge 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miscIndex: async (challenge: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challenge' is not null or undefined
            assertParamExists('miscIndex', 'challenge', challenge)
            const localVarPath = `/.well-known/acme-challenge/{challenge}`
                .replace(`{${"challenge"}}`, encodeURIComponent(String(challenge)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [challenge] 
         * @param {string} [verification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miscRenewAcmeChallenge: async (challenge?: string, verification?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/.well-known/acme-challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (challenge !== undefined) {
                localVarQueryParameter['challenge'] = challenge;
            }

            if (verification !== undefined) {
                localVarQueryParameter['verification'] = verification;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MiscApi - functional programming interface
 * @export
 */
export const MiscApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MiscApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} challenge 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async miscIndex(challenge: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.miscIndex(challenge, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [challenge] 
         * @param {string} [verification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async miscRenewAcmeChallenge(challenge?: string, verification?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.miscRenewAcmeChallenge(challenge, verification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MiscApi - factory interface
 * @export
 */
export const MiscApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MiscApiFp(configuration)
    return {
        /**
         * 
         * @param {string} challenge 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miscIndex(challenge: string, options?: any): AxiosPromise<string> {
            return localVarFp.miscIndex(challenge, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [challenge] 
         * @param {string} [verification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miscRenewAcmeChallenge(challenge?: string, verification?: string, options?: any): AxiosPromise<any> {
            return localVarFp.miscRenewAcmeChallenge(challenge, verification, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MiscApi - object-oriented interface
 * @export
 * @class MiscApi
 * @extends {BaseAPI}
 */
export class MiscApi extends BaseAPI {
    /**
     * 
     * @param {string} challenge 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscApi
     */
    public miscIndex(challenge: string, options?: AxiosRequestConfig) {
        return MiscApiFp(this.configuration).miscIndex(challenge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [challenge] 
     * @param {string} [verification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscApi
     */
    public miscRenewAcmeChallenge(challenge?: string, verification?: string, options?: AxiosRequestConfig) {
        return MiscApiFp(this.configuration).miscRenewAcmeChallenge(challenge, verification, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PaymentWebhookApi - axios parameter creator
 * @export
 */
export const PaymentWebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CcvWebhookModel} ccvWebhookModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentWebhookPost: async (ccvWebhookModel: CcvWebhookModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ccvWebhookModel' is not null or undefined
            assertParamExists('paymentWebhookPost', 'ccvWebhookModel', ccvWebhookModel)
            const localVarPath = `/api/paymentwebhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ccvWebhookModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentWebhookApi - functional programming interface
 * @export
 */
export const PaymentWebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentWebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CcvWebhookModel} ccvWebhookModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentWebhookPost(ccvWebhookModel: CcvWebhookModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentWebhookPost(ccvWebhookModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentWebhookApi - factory interface
 * @export
 */
export const PaymentWebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentWebhookApiFp(configuration)
    return {
        /**
         * 
         * @param {CcvWebhookModel} ccvWebhookModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentWebhookPost(ccvWebhookModel: CcvWebhookModel, options?: any): AxiosPromise<any> {
            return localVarFp.paymentWebhookPost(ccvWebhookModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentWebhookApi - object-oriented interface
 * @export
 * @class PaymentWebhookApi
 * @extends {BaseAPI}
 */
export class PaymentWebhookApi extends BaseAPI {
    /**
     * 
     * @param {CcvWebhookModel} ccvWebhookModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentWebhookApi
     */
    public paymentWebhookPost(ccvWebhookModel: CcvWebhookModel, options?: AxiosRequestConfig) {
        return PaymentWebhookApiFp(this.configuration).paymentWebhookPost(ccvWebhookModel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReservationsApi - axios parameter creator
 * @export
 */
export const ReservationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PublicCancelEventReservationModel} publicCancelEventReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsCancelEventReservation: async (publicCancelEventReservationModel: PublicCancelEventReservationModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicCancelEventReservationModel' is not null or undefined
            assertParamExists('reservationsCancelEventReservation', 'publicCancelEventReservationModel', publicCancelEventReservationModel)
            const localVarPath = `/api/reservations/event/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publicCancelEventReservationModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PublicCancelSubscriptionReservationModel} publicCancelSubscriptionReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsCancelSubscriptionReservation: async (publicCancelSubscriptionReservationModel: PublicCancelSubscriptionReservationModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicCancelSubscriptionReservationModel' is not null or undefined
            assertParamExists('reservationsCancelSubscriptionReservation', 'publicCancelSubscriptionReservationModel', publicCancelSubscriptionReservationModel)
            const localVarPath = `/api/reservations/subscription/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publicCancelSubscriptionReservationModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<PublicUpdateEventReservationModel>} publicUpdateEventReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsChangeEventReservations: async (publicUpdateEventReservationModel: Array<PublicUpdateEventReservationModel>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicUpdateEventReservationModel' is not null or undefined
            assertParamExists('reservationsChangeEventReservations', 'publicUpdateEventReservationModel', publicUpdateEventReservationModel)
            const localVarPath = `/api/reservations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publicUpdateEventReservationModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<PublicUpdateSubscriptionReservationModel>} publicUpdateSubscriptionReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsChangeSubscriptionReservations: async (publicUpdateSubscriptionReservationModel: Array<PublicUpdateSubscriptionReservationModel>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicUpdateSubscriptionReservationModel' is not null or undefined
            assertParamExists('reservationsChangeSubscriptionReservations', 'publicUpdateSubscriptionReservationModel', publicUpdateSubscriptionReservationModel)
            const localVarPath = `/api/reservations/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publicUpdateSubscriptionReservationModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PublicCreateEventReservationModel} publicCreateEventReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsCreateForEvent: async (publicCreateEventReservationModel: PublicCreateEventReservationModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicCreateEventReservationModel' is not null or undefined
            assertParamExists('reservationsCreateForEvent', 'publicCreateEventReservationModel', publicCreateEventReservationModel)
            const localVarPath = `/api/reservations/event/pendingreservation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publicCreateEventReservationModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PublicCreateSubscriptionReservationModel} publicCreateSubscriptionReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsCreateForSubscription: async (publicCreateSubscriptionReservationModel: PublicCreateSubscriptionReservationModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicCreateSubscriptionReservationModel' is not null or undefined
            assertParamExists('reservationsCreateForSubscription', 'publicCreateSubscriptionReservationModel', publicCreateSubscriptionReservationModel)
            const localVarPath = `/api/reservations/subscription/pendingreservation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publicCreateSubscriptionReservationModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [p] 
         * @param {number} [ps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsGetEventReservations: async (id: number, p?: number, ps?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reservationsGetEventReservations', 'id', id)
            const localVarPath = `/api/reservations/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (p !== undefined) {
                localVarQueryParameter['p'] = p;
            }

            if (ps !== undefined) {
                localVarQueryParameter['ps'] = ps;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsGetReservedSeatsForEvent: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reservationsGetReservedSeatsForEvent', 'id', id)
            const localVarPath = `/api/reservations/event/{id}/reserved`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsGetReservedSeatsForSubscription: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reservationsGetReservedSeatsForSubscription', 'id', id)
            const localVarPath = `/api/reservations/subscription/{id}/reserved`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [p] 
         * @param {number} [ps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsGetSubscriptionReservations: async (id: number, p?: number, ps?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reservationsGetSubscriptionReservations', 'id', id)
            const localVarPath = `/api/reservations/subscription/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (p !== undefined) {
                localVarQueryParameter['p'] = p;
            }

            if (ps !== undefined) {
                localVarQueryParameter['ps'] = ps;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReservationsApi - functional programming interface
 * @export
 */
export const ReservationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReservationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PublicCancelEventReservationModel} publicCancelEventReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsCancelEventReservation(publicCancelEventReservationModel: PublicCancelEventReservationModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsCancelEventReservation(publicCancelEventReservationModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PublicCancelSubscriptionReservationModel} publicCancelSubscriptionReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsCancelSubscriptionReservation(publicCancelSubscriptionReservationModel: PublicCancelSubscriptionReservationModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsCancelSubscriptionReservation(publicCancelSubscriptionReservationModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<PublicUpdateEventReservationModel>} publicUpdateEventReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsChangeEventReservations(publicUpdateEventReservationModel: Array<PublicUpdateEventReservationModel>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateReservationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsChangeEventReservations(publicUpdateEventReservationModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<PublicUpdateSubscriptionReservationModel>} publicUpdateSubscriptionReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsChangeSubscriptionReservations(publicUpdateSubscriptionReservationModel: Array<PublicUpdateSubscriptionReservationModel>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateReservationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsChangeSubscriptionReservations(publicUpdateSubscriptionReservationModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PublicCreateEventReservationModel} publicCreateEventReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsCreateForEvent(publicCreateEventReservationModel: PublicCreateEventReservationModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reservation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsCreateForEvent(publicCreateEventReservationModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PublicCreateSubscriptionReservationModel} publicCreateSubscriptionReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsCreateForSubscription(publicCreateSubscriptionReservationModel: PublicCreateSubscriptionReservationModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reservation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsCreateForSubscription(publicCreateSubscriptionReservationModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [p] 
         * @param {number} [ps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsGetEventReservations(id: number, p?: number, ps?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfReservationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsGetEventReservations(id, p, ps, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsGetReservedSeatsForEvent(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationSeatStatusWithCodes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsGetReservedSeatsForEvent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsGetReservedSeatsForSubscription(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationSeatStatusWithCodes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsGetReservedSeatsForSubscription(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [p] 
         * @param {number} [ps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsGetSubscriptionReservations(id: number, p?: number, ps?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfReservationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsGetSubscriptionReservations(id, p, ps, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReservationsApi - factory interface
 * @export
 */
export const ReservationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReservationsApiFp(configuration)
    return {
        /**
         * 
         * @param {PublicCancelEventReservationModel} publicCancelEventReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsCancelEventReservation(publicCancelEventReservationModel: PublicCancelEventReservationModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.reservationsCancelEventReservation(publicCancelEventReservationModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublicCancelSubscriptionReservationModel} publicCancelSubscriptionReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsCancelSubscriptionReservation(publicCancelSubscriptionReservationModel: PublicCancelSubscriptionReservationModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.reservationsCancelSubscriptionReservation(publicCancelSubscriptionReservationModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<PublicUpdateEventReservationModel>} publicUpdateEventReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsChangeEventReservations(publicUpdateEventReservationModel: Array<PublicUpdateEventReservationModel>, options?: any): AxiosPromise<UpdateReservationResponse> {
            return localVarFp.reservationsChangeEventReservations(publicUpdateEventReservationModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<PublicUpdateSubscriptionReservationModel>} publicUpdateSubscriptionReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsChangeSubscriptionReservations(publicUpdateSubscriptionReservationModel: Array<PublicUpdateSubscriptionReservationModel>, options?: any): AxiosPromise<UpdateReservationResponse> {
            return localVarFp.reservationsChangeSubscriptionReservations(publicUpdateSubscriptionReservationModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublicCreateEventReservationModel} publicCreateEventReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsCreateForEvent(publicCreateEventReservationModel: PublicCreateEventReservationModel, options?: any): AxiosPromise<Reservation> {
            return localVarFp.reservationsCreateForEvent(publicCreateEventReservationModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublicCreateSubscriptionReservationModel} publicCreateSubscriptionReservationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsCreateForSubscription(publicCreateSubscriptionReservationModel: PublicCreateSubscriptionReservationModel, options?: any): AxiosPromise<Reservation> {
            return localVarFp.reservationsCreateForSubscription(publicCreateSubscriptionReservationModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [p] 
         * @param {number} [ps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsGetEventReservations(id: number, p?: number, ps?: number, options?: any): AxiosPromise<PagedResultOfReservationDto> {
            return localVarFp.reservationsGetEventReservations(id, p, ps, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsGetReservedSeatsForEvent(id: number, options?: any): AxiosPromise<ReservationSeatStatusWithCodes> {
            return localVarFp.reservationsGetReservedSeatsForEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsGetReservedSeatsForSubscription(id: number, options?: any): AxiosPromise<ReservationSeatStatusWithCodes> {
            return localVarFp.reservationsGetReservedSeatsForSubscription(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [p] 
         * @param {number} [ps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsGetSubscriptionReservations(id: number, p?: number, ps?: number, options?: any): AxiosPromise<PagedResultOfReservationDto> {
            return localVarFp.reservationsGetSubscriptionReservations(id, p, ps, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReservationsApi - object-oriented interface
 * @export
 * @class ReservationsApi
 * @extends {BaseAPI}
 */
export class ReservationsApi extends BaseAPI {
    /**
     * 
     * @param {PublicCancelEventReservationModel} publicCancelEventReservationModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public reservationsCancelEventReservation(publicCancelEventReservationModel: PublicCancelEventReservationModel, options?: AxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsCancelEventReservation(publicCancelEventReservationModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublicCancelSubscriptionReservationModel} publicCancelSubscriptionReservationModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public reservationsCancelSubscriptionReservation(publicCancelSubscriptionReservationModel: PublicCancelSubscriptionReservationModel, options?: AxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsCancelSubscriptionReservation(publicCancelSubscriptionReservationModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<PublicUpdateEventReservationModel>} publicUpdateEventReservationModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public reservationsChangeEventReservations(publicUpdateEventReservationModel: Array<PublicUpdateEventReservationModel>, options?: AxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsChangeEventReservations(publicUpdateEventReservationModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<PublicUpdateSubscriptionReservationModel>} publicUpdateSubscriptionReservationModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public reservationsChangeSubscriptionReservations(publicUpdateSubscriptionReservationModel: Array<PublicUpdateSubscriptionReservationModel>, options?: AxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsChangeSubscriptionReservations(publicUpdateSubscriptionReservationModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublicCreateEventReservationModel} publicCreateEventReservationModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public reservationsCreateForEvent(publicCreateEventReservationModel: PublicCreateEventReservationModel, options?: AxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsCreateForEvent(publicCreateEventReservationModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublicCreateSubscriptionReservationModel} publicCreateSubscriptionReservationModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public reservationsCreateForSubscription(publicCreateSubscriptionReservationModel: PublicCreateSubscriptionReservationModel, options?: AxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsCreateForSubscription(publicCreateSubscriptionReservationModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} [p] 
     * @param {number} [ps] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public reservationsGetEventReservations(id: number, p?: number, ps?: number, options?: AxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsGetEventReservations(id, p, ps, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public reservationsGetReservedSeatsForEvent(id: number, options?: AxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsGetReservedSeatsForEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public reservationsGetReservedSeatsForSubscription(id: number, options?: AxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsGetReservedSeatsForSubscription(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} [p] 
     * @param {number} [ps] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public reservationsGetSubscriptionReservations(id: number, p?: number, ps?: number, options?: AxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsGetSubscriptionReservations(id, p, ps, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SeatsApi - axios parameter creator
 * @export
 */
export const SeatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seatsGetConfigForEvent: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('seatsGetConfigForEvent', 'id', id)
            const localVarPath = `/api/seats/event/{id}/config`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seatsGetConfigForSubscription: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('seatsGetConfigForSubscription', 'id', id)
            const localVarPath = `/api/seats/subscription/{id}/config`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seatsGetForEvent: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('seatsGetForEvent', 'id', id)
            const localVarPath = `/api/seats/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seatsGetForSubscription: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('seatsGetForSubscription', 'id', id)
            const localVarPath = `/api/seats/subscription/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SeatsApi - functional programming interface
 * @export
 */
export const SeatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SeatsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seatsGetConfigForEvent(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeatConfigurationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seatsGetConfigForEvent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seatsGetConfigForSubscription(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeatConfigurationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seatsGetConfigForSubscription(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seatsGetForEvent(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfEventSeatSmallDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seatsGetForEvent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seatsGetForSubscription(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfSubscriptionSeatSmallDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seatsGetForSubscription(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SeatsApi - factory interface
 * @export
 */
export const SeatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SeatsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seatsGetConfigForEvent(id: number, options?: any): AxiosPromise<Array<SeatConfigurationDto>> {
            return localVarFp.seatsGetConfigForEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seatsGetConfigForSubscription(id: number, options?: any): AxiosPromise<Array<SeatConfigurationDto>> {
            return localVarFp.seatsGetConfigForSubscription(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seatsGetForEvent(id: number, options?: any): AxiosPromise<PagedResultOfEventSeatSmallDto> {
            return localVarFp.seatsGetForEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seatsGetForSubscription(id: number, options?: any): AxiosPromise<PagedResultOfSubscriptionSeatSmallDto> {
            return localVarFp.seatsGetForSubscription(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SeatsApi - object-oriented interface
 * @export
 * @class SeatsApi
 * @extends {BaseAPI}
 */
export class SeatsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeatsApi
     */
    public seatsGetConfigForEvent(id: number, options?: AxiosRequestConfig) {
        return SeatsApiFp(this.configuration).seatsGetConfigForEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeatsApi
     */
    public seatsGetConfigForSubscription(id: number, options?: AxiosRequestConfig) {
        return SeatsApiFp(this.configuration).seatsGetConfigForSubscription(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeatsApi
     */
    public seatsGetForEvent(id: number, options?: AxiosRequestConfig) {
        return SeatsApiFp(this.configuration).seatsGetForEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeatsApi
     */
    public seatsGetForSubscription(id: number, options?: AxiosRequestConfig) {
        return SeatsApiFp(this.configuration).seatsGetForSubscription(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TicketsApi - axios parameter creator
 * @export
 */
export const TicketsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ScanTicketCommand} scanTicketCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ticketsScanTicketCode: async (scanTicketCommand: ScanTicketCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanTicketCommand' is not null or undefined
            assertParamExists('ticketsScanTicketCode', 'scanTicketCommand', scanTicketCommand)
            const localVarPath = `/api/tickets/scan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scanTicketCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TicketsApi - functional programming interface
 * @export
 */
export const TicketsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TicketsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ScanTicketCommand} scanTicketCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ticketsScanTicketCode(scanTicketCommand: ScanTicketCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScanTicketResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ticketsScanTicketCode(scanTicketCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TicketsApi - factory interface
 * @export
 */
export const TicketsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TicketsApiFp(configuration)
    return {
        /**
         * 
         * @param {ScanTicketCommand} scanTicketCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ticketsScanTicketCode(scanTicketCommand: ScanTicketCommand, options?: any): AxiosPromise<ScanTicketResponse> {
            return localVarFp.ticketsScanTicketCode(scanTicketCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TicketsApi - object-oriented interface
 * @export
 * @class TicketsApi
 * @extends {BaseAPI}
 */
export class TicketsApi extends BaseAPI {
    /**
     * 
     * @param {ScanTicketCommand} scanTicketCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public ticketsScanTicketCode(scanTicketCommand: ScanTicketCommand, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).ticketsScanTicketCode(scanTicketCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


